(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PatternInfoController', PatternInfoController);

    PatternInfoController.$inject = ['$scope', '$state', 'PatternInfo', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'PatternInfoCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom', 'ServantCustom'];

    function PatternInfoController($scope, $state, PatternInfo, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, PatternInfoCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom, ServantCustom) {

        var vm = this;
        vm.patternInfo = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.onServiceChanged = onServiceChanged;
        vm.selectedServiceItem = null;
        vm.addServiceToPattern = addServiceToPattern;
        vm.removeFromPattern = removeFromPattern;
        vm.servantList = [];
        vm.selectedServantChanged = selectedServantChanged;


        initDefault();
        loadAll();

        function initDefault() {

            if (!vm.patternInfo || !vm.patternInfo.id) {
                vm.patternInfo.companyId = 1;
                vm.patternInfo.description = '';
                vm.patternInfo.pattern = '';
                vm.patternInfo.patternStructure = {};
            }


        }

        function loadAll() {
            $translatePartialLoader.addPart('patternInfo');
            $translatePartialLoader.addPart('patternStatus');
            $translatePartialLoader.addPart('servant');
            loadAllServants();

        }

        function loadAllServants() {
            ServantCustom.getServantsHaveServicesByCurrentCompany().query().$promise.then(function (result) {
                    vm.servantList = result;
                }
            )
        }

        function selectedServantChanged() {
            if (vm.patternInfo && vm.patternInfo.servantId) {
                getServantServices(vm.patternInfo.servantId);
            }
        }

        function getServantServices(servantId) {

            if (servantId) {
                ServiceItemCustom.getServiceItemsByServantId(servantId).query().$promise.then(function (result) {
                        vm.allServiceItems = result;
                    }
                );
            }
        }

        function save() {
            vm.isSaving = true;

            if (vm.patternInfo.id !== null) {
                vm.patternInfo.description = '';
                vm.patternInfo.pattern = '';
                PatternInfo.update(vm.patternInfo, onSaveSuccess, onSaveError);
            } else {
                PatternInfo.save(vm.patternInfo, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:patternInfoUpdate', result);
                $state.go('supplierPanel.editPatternInfo', {id: result.id});

                loadAll();

            }

        }


        function onServiceChanged(item) {
        }

        function addServiceToPattern() {
            if (vm.selectedServiceItem) {
                if (!vm.patternInfo.patternStructure) {
                    vm.patternInfo.patternStructure = {};
                }

                var item = {};
                var orderNo = 1;
                if (vm.patternInfo.patternStructure.patternItems != null && vm.patternInfo.patternStructure.patternItems.length > 0)
                    orderNo = vm.patternInfo.patternStructure.patternItems.length + 1;
                else
                    vm.patternInfo.patternStructure.patternItems = [];

                item.orderNo = orderNo;
                item.serviceId = vm.selectedServiceItem.id;
                item.maxCapacity = vm.selectedServiceItem.capacityInfo.qty;
                item.serviceItem = vm.selectedServiceItem;

                vm.patternInfo.patternStructure.patternItems.push(item);
            }
        }

        function removeFromPattern(item) {

            vm.patternInfo.patternStructure.patternItems = vm.patternInfo.patternStructure.patternItems.filter(function (value) {
                return (value.orderNo != item.orderNo)
            })

            // regenerate orderNo
            var orderNo = 1;
            angular.forEach(vm.patternInfo.patternStructure.patternItems, function (c) {

                c.orderNo = orderNo;
                orderNo++;
            });


        }


    }
})();
